import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/enterprise/basestation-xg.png";
import type { Product } from "../../types";
import { wifiOutdoor } from "../product-list-groups/wifi-outdoor";
import {
  antennaType,
  connectedDevices,
  dedicatedSpectral,
  extendedRangeMode6Ghz,
  fipsCompliance,
  powerMethodPoe,
  radio6Ghz,
  redundantRj45Port,
  rfFilteringTechnology,
  uplink,
  weatherproofing,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../properties";

export const baseStationXG: Product = {
  id: "baseStationXG",
  productTitle: "WiFi BaseStation XG",
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.WiFi}/uwb-xg`],
  storePathParts: {
    productSlug: "uwb-xg",
    category: UniFiChildCategorySlug.WiFiMegaCapacity,
  },
  descriptionMaxWidth: 320,
  image: { src: image, width: 200, height: 160 },
  sku: "UWB-XG",
  description: "baseStationXG.description",
  productListGroup: wifiOutdoor,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '471.1 x 257.5 x 94.3 mm\n(18.6 x 10.1 x 3.7")',
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "baseStationXG.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: extendedRangeMode6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: dedicatedSpectral.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "wifiPowerMethod",
      value: { type: "string", value: "PoE++" },
    },
    {
      propertyId: rfFilteringTechnology.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: antennaType.id,
      value: {
        type: "translation",
        value: "baseStationXg.antennaType.selectableDirectional",
        asterisk: 1,
      },
    },
    {
      propertyId: wifiCoverage.id,
      value: {
        type: "translation",
        value: "baseStationXG.wifiCoverage",
      },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "1,500+" },
    },
    {
      propertyId: weatherproofing.id,
      value: { type: "string", value: "IP67" },
    },

    {
      propertyId: powerMethodPoe.id,
      value: { type: "string", value: "PoE++" },
    },
    {
      propertyId: uplink.id,
      value: { type: "translation", value: "baseStationXG.uplink" },
    },
    {
      propertyId: redundantRj45Port.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.wallPole",
      },
    },
    {
      propertyId: fipsCompliance.id,
      value: { type: "boolean", value: false },
    },
  ],
  notes: ["baseStationXG.notes.1"],
};
